import { deleteFirebaseTokenFromBrowser } from "src/firebase";

export const redirectTo = (path) => {
   window.location.href = "#" + path;
   // window.push('/login')
};

export const logOut = () => {
   deleteFirebaseTokenFromBrowser();
   localStorage.clear();
   redirectTo("/login");
};
